import React, { useState, useEffect } from 'react';
import { FileCheck, User, X, Calendar } from 'lucide-react';
import axiosInstance from '../../utils/axiosConfig';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { formatFecha } from '../gh';

const ConstanciasPendientesWidget = () => {
    const { user } = useAuth();
    const isGH = user?.role === 'gh';

    const [pendientes, setPendientes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [dismissed, setDismissed] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const today = new Date().toDateString();
        if (localStorage.getItem(`widget_dismiss_constancias_${today}`)) setDismissed(true);
    }, []);

    useEffect(() => {
        if (!isGH) { setLoading(false); return; }
        let activo = true;
        (async () => {
            try {
                const res = await axiosInstance.get('/api/constancias-trabajo', { params: { estado: 'pendiente' } });
                if (activo) setPendientes(Array.isArray(res.data) ? res.data : []);
            } catch (err) {
                console.error('Error cargando constancias pendientes:', err);
            } finally {
                if (activo) setLoading(false);
            }
        })();
        return () => { activo = false; };
    }, [isGH]);

    const handleDismiss = () => {
        if (window.confirm('¿Deseas ocultar este widget por hoy?')) {
            const today = new Date().toDateString();
            localStorage.setItem(`widget_dismiss_constancias_${today}`, 'true');
            setDismissed(true);
        }
    };

    if (!isGH || loading || dismissed || pendientes.length === 0) return null;

    const total = pendientes.length;

    return (
        <section className="relative rounded-2xl overflow-hidden border border-sky-200 shadow-sm group">
            <button
                onClick={handleDismiss}
                className="absolute top-3 right-3 z-20 w-6 h-6 rounded-full bg-white/80 backdrop-blur-sm text-gray-400 hover:text-gray-600 hover:bg-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all shadow-sm"
                title="Ocultar por hoy"
            >
                <X size={14} />
            </button>

            <div className="bg-gradient-to-r from-sky-500 to-cyan-600 px-5 py-4 text-white">
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-white/20 backdrop-blur-sm flex items-center justify-center">
                        <FileCheck size={20} />
                    </div>
                    <div>
                        <h3 className="font-bold text-lg">Constancias por preparar</h3>
                        <p className="text-white/80 text-sm">
                            {total} {total !== 1 ? 'esperan' : 'espera'} por Gestión Humana
                        </p>
                    </div>
                </div>
            </div>

            <div className="bg-sky-50 p-5 space-y-3">
                {pendientes.slice(0, 3).map(c => (
                    <div key={c.id} className="bg-white rounded-xl p-3 border border-gray-100 shadow-sm">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center gap-2 min-w-0">
                                <User size={14} className="text-gray-400 flex-shrink-0" />
                                <span className="text-sm font-medium text-gray-900 truncate">{c.empleado_nombre}</span>
                            </div>
                            {c.incluir_salario && (
                                <span className="text-xs text-sky-600 bg-sky-50 px-2 py-0.5 rounded-full font-medium flex-shrink-0 ml-2">
                                    Con sueldo
                                </span>
                            )}
                        </div>
                        {c.fecha_solicitud && (
                            <div className="flex items-center gap-2 mt-1.5 text-xs text-gray-500">
                                <Calendar size={12} />
                                <span>{formatFecha(String(c.fecha_solicitud).slice(0, 10))}</span>
                            </div>
                        )}
                    </div>
                ))}

                {total > 3 && (
                    <p className="text-xs text-sky-600 text-center font-medium">
                        y {total - 3} más...
                    </p>
                )}

                <button
                    onClick={() => navigate('/constancia-trabajo')}
                    className="w-full py-3 rounded-xl bg-sura-blue text-white font-medium flex items-center justify-center gap-2 hover:bg-sura-blue-dark transition-colors"
                >
                    Preparar constancias
                </button>
            </div>
        </section>
    );
};

export default ConstanciasPendientesWidget;
